<template>
    <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field v-model="name" :rules="nameRules" label="お名前" required></v-text-field>
        <v-text-field v-model="email" :rules="emailRules" label="メールアドレス" required></v-text-field>
        <v-text-field v-model="phone" :rules="phoneRules" label="電話番号"></v-text-field>
        <v-textarea v-model="content" label="お問い合わせ内容" reqired></v-textarea>

        <v-checkbox v-model="checkbox" :rules="[v => !!v || 'You must agree to continue!']" label="Do you agree?"
            required></v-checkbox>

        <v-btn :disabled="!valid" color="success" class="mr-4" @click="validate">
            Validate
        </v-btn>
    </v-form>
</template>
  
<script>
export default {
    name: 'InquiryForm',
    data: () => ({
        valid: true,
        name: '',
        nameRules: [
            v => !!v || 'Name is required',
            v => (v && v.length <= 10) || 'Name must be less than 10 characters',
        ],
        phoneRules: [
            v => /^[0-9]*$]/.test(v) || 'phone must be valid',
        ],
        email: '',
        phone: '',
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        content: '',
        checkbox: false,
    }),

    methods: {
        validate() {
            this.$refs.form.validate()
        },
    },
}
</script>
  